import { ManageMarketingListMembers } from "./ManageMarketingListMembers";
import { MarketingListMembers } from "./MarketingListMembers";

// Kept with the page, as contactFieldComponents is, and handed over by the marketing
// list record definition.
export const marketingListFieldComponents = {
  marketingListMembers: MarketingListMembers,
  manageMarketingListMembers: ManageMarketingListMembers,
};
